import './App.css';
import startup_kinito from './assets/sounds/Startupa2c.ogg'
import Profile from './Profile.js';
import CWindow from './CWindow.js';
import Notes from './Notes.js';
import iqgicon from './assets/images/iqgiconoutline.png';
import IncorrectQuotes from './assets/subpages/incorrect-quotes-generator.js';
import flarebg from './assets/images/yontelecasterbboy.png';
import flarepfp from './assets/images/flare_pfp.png';
import navybg from './assets/images/yonyjlpm.png';
import navypfp from './assets/images/navy_pfp.png';
import twibg from './assets/images/turnip.jpg';
import twipfp from './assets/images/temp_twi_pfp.png';

function getTime(hour, min) {
  const uwu = new Date();
  uwu.setUTCHours((hour + 4) % 24); // philippine time
  uwu.setUTCMinutes(min);
  const uwustr = uwu.toLocaleTimeString();
  return uwustr.substring(0, uwustr.length - 6) + uwustr.substring(uwustr.length - 3);
}

function App() {
  const aboutUs = <CWindow open='true' offset={{x: -7, y:0}}>
  {{
    id: "AboutUs",
    icon: "📚",
    contents: [{
      title: 'zycaon 🦈🦈🐟🐟🐱🐱',
      content: <Profile>{{
        name: 'zackary',
        pronouns: 'he/they',
        content: <div className='lecontents allowance'>
        <div style={{height: 'fit-content',
                    overflowWrap: 'break-word',
                    overflowY: 'auto',}}>

        {'ฅ ≽^⸝⸝•⩊•⸝⸝マ≼\xa0\xa0\xa0\xa0𓍢ִ໋ .°˖✧'}
        <br/>meowdy! i'm zackary!! or zycaon sometimes!!!
        <br/>
        <br/>i like to do a lot of things! you'll often find me
        <br/>drawing digital art and programming silly stuff :3c
        <br/><br/><code>♫ ~ i'm a secret elementary school student</code>
        </div><br/>

        {/* style={{top: '14.75em'}} */}
        <blockquote className='anchright'>
          <div className='blockTitle'>I'm a:</div>
          <ul>
            <li>Femboy (?) ≽^⸝•ヮ•⸝マ≼
      </li><li>Artist & Programmer ≽^⸝ ╸ˋ⩊ˊ╸⸝マ≼
      {/* </li><li>Insomniac ≽^⸝ ╥ ⩊ ╥;⸝マ≼ */}
      </li><li>AuDHD + Anxiety ≽^⸝ ╸ヮ╸"⸝マ≼
      </li><li>Midnight: {getTime(12, 0)} ≽^⸝•⩊•⸝マ≼
      </li></ul>
        </blockquote>

        <blockquote className='anch center'
                    style={{top: '27em'}}>
          <div className='blockTitleCenter'>🔗🌳</div>
          <span><a className='blue' href='https://bsky.app/profile/catwoofer.bsky.social'>Bluesky</a> (catwoofer)</span>
          <span><a className='blue' href='https://discord.com/channels/@me/1119550192123924493'>Discord</a> (catwoofer_)</span>
          {/* <br/> */}
          <hr/>
          <span><a className='blue' href='https://www.youtube.com/@remiicatboy'>YouTube</a> (@remiicatboy)</span>
          {/* <br/> */}
          <hr/>
          <span><a className='blue' href='https://namemc.com/profile/remiiowo.1'>Minecraft</a> <i>(remiiowo)</i></span>
          <span><a className='blue' href='https://www.roblox.com/users/4542694269/profile'>Roblox</a> <i>(subpurrowo)</i></span>
        </blockquote>

        </div>,
        background: {
          banner: {
            image: flarebg,
            alt: "a screenshot from YonKaGor's cover of Telecaster BBoy'"
          },
          profile: {
            image: flarepfp,
            alt: "zackary's profile picture!"
          },
          text: {
            link: {
              regular: "rgb(124, 18, 18)",
              hover: "rgb(167, 22, 22)",
              visited: "rgb(73, 22, 35)",
              vhover: "rgb(128, 18, 46)"
            },
            name: "black",
            regular: "white",
            pronoun: "#382429",
            label: "#482129"
          },
          backdrop: "#c95371, #ed6d9e, #2c215e",
          border: "#FABA99, #17092C"
        },
        labels: [
          {name: 'Vincian', url: 'https://www.lgbtqia.wiki/wiki/Vincian', hover: 'it means gay (and a bit more)'},
          {name: 'Nonbinary', url: 'https://nonbinary.wiki/wiki/Nonbinary', hover: 'my relationship with gender is complicated!! but tldr; im a dude'}
          // {name: 'Median [Core]', url: 'https://pluralpedia.org/w/Median', hover: 'core/host of the system!!'},
          // {name: 'Demiboy', url: 'https://antifandom.com/gender/wiki/Demiboy', hover: 'gonna try this out for a while :3c'},
          // {name: 'Therian (Cat)', hover: "i don't have a good explanation for this..."}
        ]
      }}</Profile>
    },
    {
      title: 'Navy',
      content: <Profile>{{
        name: 'Navy',
        pronouns: 'he/they',
        content: <div className='lecontents'>
        <div className='smallspace'
            style={{height: 'fit-content',
                    overflowWrap: 'break-word',
                    overflowY: 'visible',}}>

        {'≽^⸝•⩊•⸝マ≼\xa0\xa0\xa0⋆｡°✩'}
        <br/>Hey there!! I'm Navy.
        <br/>uuh. to do: write this later
        <br/>
        </div><br/>

        <blockquote className='anchright'>
          <div className='blockTitle'>I'm a:</div>
          <ul>
            {/* <li>Headmate [ Facet ] ≽^⸝ ╸⩊ ╸⸝マ≼
      </li><li>oooo mysterious ≽^⸝ ╥ ⩊ ╥ ⸝マ≼
      </li><li>Moral Support ≽^⸝ •⩊ • '⸝マ≼  ≽^⸝ / ⩊ / ⸝マ≼
      </li> */}
      <li>Midnight: {getTime(12, 0)} ≽^⸝ ╸ヮ╸ '⸝マ≼
      </li></ul>
        </blockquote>

        </div>,
        background: {
          banner: {
            image: navybg,
            alt: "navy's background image"
          },
          profile: {
            image: navypfp,
            alt: "it's navy!! woahhh!!"
          },
          text: {
            link: {
              regular: "#8191eb",
              hover: "#aab6fa",
              visited: "#7788ed",
              vhover: "#97a6fc"
            },
            name: "white",
            regular: "white",
            pronoun: "#bbc3ed",
            label: "#6c78cc"
          },
          backdrop: "#cffcff, #3e5285, #11141f",
          // backdrop: "#2D3A5C, #3e5285, #11141f",
          border: "#FABA99, #17092C"
        },
        labels: [
          {name: 'Vincian', url: 'https://www.lgbtqia.wiki/wiki/Vincian', hover: "we're all gay in this household /lh"},
          {name: 'Grayromantic', url: 'https://lgbtqia.fandom.com/wiki/Aromantic_spectrum', hover: "can't exactly place where on the aspec they are, but oh well"}
        ]
      }}</Profile>
    },
    // {
    //   title: 'Twi',
    //   content: <Profile>{{
    //     name: 'Twi',
    //     pronouns: 'he/they',
    //     content: <>uuh insert text here later :3 :3 :3 :3 <br/>
    //                 tbh we're on the fence about including twi in here</>,
    //     background: {
    //       banner: {
    //         image: twibg,
    //         alt: "twi's background image"
    //       },
    //       profile: {
    //         image: twipfp,
    //         alt: "placeholder pfp for twi"
    //       },
    //       text: {
    //         link: {
    //           regular: "#7988e0",
    //           hover: "#93a2fa",
    //           visited: "#6775c9",
    //           vhover: "#7685db"
    //         },
    //         name: "black",
    //         regular: "black",
    //         pronoun: "#313e4a",
    //         label: "#4F599C"
    //       },
    //       backdrop: "#badbff, #cffcff, #5751a8",
    //       // backdrop: "#badbff, #cffcff, #54ffaa",
    //       border: "#FABA99, #17092C"
    //     },
    //     labels: [
    //       {name: 'Vincian', url: 'https://www.lgbtqia.wiki/wiki/Vincian', hover: 'unsure about this one'}
    //     ]
    //   }}</Profile>
    // }
  ]}}</CWindow>

  let nyanya;
  let started = false;
  const kinito_audio = new Audio(startup_kinito);

  setTimeout(() => {
    nyanya = document.getElementById("App");
  }, 0);

  const start = (e) => {
    console.log('trying my best to start here... ' + started);
    if (!started && kinito_audio.paused && !kinito_audio.currentTime) {
      started = true;
      if (nyanya.getAttribute('initializing') == 'processing') {
        nomore();

        setTimeout(() => {
          kinito_audio.play();
          nyanya.setAttribute('initializing', 'true');
          setTimeout(() => {
            nyanya.removeAttribute('initializing');
          }, 5100)
        }, 500)
      }
    }
  }

  const nomore = () => {
    const meowmeow = document.getElementById("notice");
    document.removeEventListener('keydown', start);
    document.removeEventListener('mousedown', regPress);
    document.removeEventListener('mouseup', decPress);
    meowmeow.setAttribute('fading', 'true');
    kinito_audio.preservesPitch = false;
    kinito_audio.playbackRate = 1.25;
  }

  let holding = 0;
  let pressCheck;
  const regPress = (e) => {
    holding++;
    if (!pressCheck) {
      pressCheck = setTimeout(() => {
        if (holding > 0 && !started && kinito_audio.paused && !kinito_audio.currentTime) {
          started = true;
          nyanya.setAttribute('initializing', 'fast');
          nomore();
          
          if (kinito_audio.paused && !kinito_audio.currentTime)
            kinito_audio.play();

          setTimeout(() => {
            nyanya.removeAttribute('initializing');
          }, 1100)
        }
        pressCheck = null;
      }, 500)
    }
  }

  const decPress = () => {
    holding--;
  };

  // using deprecated event, because keys like 'alt' will break for some reason
  document.addEventListener('keypress', start);
  document.addEventListener('mousedown', regPress);
  document.addEventListener('mouseup', decPress);

  return (
    <>
      <button id="notice" onClick={start}>
        interact to show page <br/>
  <sub>this page plays sound, which requires your interaction before playing <br/>
       you may long-press the page to skip the intro
  </sub>
      </button>
      <div id="App" initializing='processing'>
        <div>
          {aboutUs}
          <CWindow>{{
            id: "Incorrect Quotes Generator",
            icon: <img src={iqgicon}/>,
            contents: <div><div className='defaultDiv'><IncorrectQuotes/></div></div>
        }}</CWindow>
          <CWindow open='true' offset={{x: 30, y:12}}>{{
            id: "notes.txt",
            icon: "📒",
            contents: <span><Notes/></span>
        }}</CWindow>
        </div>
        <div id='Taskbar'>
          <div id='TaskbarContents'/>
          <div id='TaskbarWidgets'> </div>
        </div>
      </div>
    </>
  );
}

export default App;
